import React from "react";

const Creative = ({address, creative, compact}) => {
    return(
        <div className={`d-flex flex-column justify-content-between creative-box ${ compact ? 'compact' : ''}`}>
            <div className="">
              {creative.detail ?
                    <div className="creative-name">
                        <a href={creative.path} className="d-flex justify-content-between text-primary align-items-center">
                            <span>{creative.name}</span> <i className="fal fa-arrow-right animate-right pr-2"/>
                        </a>
                    </div> :
                    <div className="creative-name">
                        {creative.name}
                    </div>
                }
              {!compact && Array.isArray(creative.tags) &&
              <div className="creative-tags d-block px-1 pt-3">
                {creative.tags.map((tag) =>
                  <div className="pr-1 creative-tag float-left">
                    {tag.value}
                  </div>
                )}
              </div>
              }
          </div>

            { compact &&
            <div className="creative-address">{address}</div>
            }
            { !compact && creative.award && creative.awards &&
            <div className="creative-award">
                <div className="award-winning w-100">
                    <div className="award-string">{creative.awards[0]['name']}</div>
                </div>
                <img src={`/themes/custom/apbc/images/${creative.awards[0]['shape']}.png`} class="award-shape" alt="award"/>
            </div>
            }

        </div>
    )
};

export default Creative;
